export default {
  common: {
    breadcrumb: {
      home: '首页',
    },
    learnMore: '了解更多',
  },
  heroTitle: 'IFS 解决方案',
  heroSubtitle: 'IFS Solutions',
  heroImagePC: 'ifs/bg-pc.png',
  heroImageSP: 'ifs/bg-sp.png',
  heroPartner: 'ifs/partner.png',
  heroDesc:
    'IFS 是企业数字化转型的核心基石。我们深度整合ERP、EAM、FSM等核心系统，融合AI与IoT & 机器人技术，为企业提供从规划到落地的全链路数字化解决方案，助力企业实现高效运营与智能化升级。',
  corporatePartnerships: {
    title: '飞狼数码（上海）有限公司是 IFS 大中华区正式授权总代理',
    link: {
      label: 'IFS 解决方案官网',
      path: 'https://www.ifs.com/en',
    },
  },
  intro: [
    'IFS以ERP、EAM、FSM等核心业务能力为基础，将企业运营、资产管理与现场服务融为一体，并通过人工智能（AI）与智能自动化进一步提升企业运营能力。',
    '平台打通企业关键业务流程与数据，帮助企业实现统一管理、实时协同与智能决策。',
    '我们结合IFS平台、行业经验与AI技术，为企业提供从咨询规划、系统实施到集成开发的数字化解决方案，持续推动业务流程优化与企业智能化升级。',
  ],
  solutionsTitle: '解决方案',
  solutionsSubtitle: 'Our Solutions',
  solutions: [
    {
      icon: 'si/si-icons/database.svg',
      title: '企业资源计划 (ERP)',
      desc:
        '整合企业财务、采购、生产、销售、人力资源等核心业务流程，实现数据统一管理与实时决策支持，提升运营效率。',
      path: 'https://www.ifs.com/en/products/erp',
    },
    {
      icon: 'si/si-icons/wrench.svg',
      title: '企业资产管理 (EAM)',
      desc:
        '覆盖资产全生命周期管理，从采购入库到运维报废，实现预防性维护、工单管理与合规审计，降低设备停机时间与维护成本。',
      path: 'https://www.ifs.com/en/products/alm/eam',
    },
    {
      icon: 'ifs/user.svg',
      title: '现场服务管理(FSM)',
      desc:
        '整合工单管理、人员调度、现场作业、设备维护等业务流程，实现服务资源统一管理与实时协同，提升现场服务效率与客户满意度。',
      path: 'https://www.ifs.com/en/products/fsm',
    },
    {
      icon: 'ifs/vector.svg',
      title: '企业 AI 解决方案',
      desc:
        '融合人工智能与企业核心业务流程，通过智能预测、数据分析、自动化处理与辅助决策，将企业数据转化为业务洞察，帮助企业优化资源配置、提升运营效率，实现更加智能、高效的企业管理。',
      path: 'https://www.ifs.com/en/products/ai',
    },
  ],
  scenariosTitle: '应用场景',
  scenariosSubtitle: 'Use Cases',
  scenariosDescription: 'IFS为不同行业提供贴合业务特性的数字化解决方案。',
  scenarios: [
    {
      icon: 'si/si-icons/factory.svg',
      title: '制造业',
      titleEn: 'Manufacturing',
      desc: '整车装配线实时节拍管控、零部件追溯、质量 gate 管理，生产效率提升15%以上。',
    },
    {
      icon: 'ifs/aerospace.svg',
      title: '航空航天与国防',
      titleEn: 'Aerospace & Defense',
      desc: '应对复杂产品、资产和供应链管理需求，实现从生产到维护的全生命周期管理。',
    },
    {
      icon: 'ifs/energy.svg',
      title: '能源与公用事业',
      titleEn: 'Energy & Utilities',
      desc: '围绕关键资产、维护计划与现场服务，实现资产全生命周期管理与高效运营。',
    },
    {
      icon: 'ifs/engineering.svg',
      title: '工程与建筑',
      titleEn: 'Engineering & Construction',
      desc:
        '整合项目管理、采购、成本控制与现场作业，实现从项目规划到交付的全流程管理，提升项目执行效率与资源利用率。',
    },
    {
      icon: 'ifs/telecommunications.svg',
      title: '电信',
      titleEn: 'Telecommunications',
      desc:
        '整合网络资产、现场服务、人员调度与维护流程，实现服务资源高效协同，提升服务响应速度与运营效率。',
    },
    {
      icon: 'ifs/transportation.svg',
      title: '交通运输',
      titleEn: 'Transportation',
      desc:
        '整合资产、维护、调度与运营管理，借助实时数据和AI预测，提升交通运输企业的资产可靠性、运营效率与服务质量。',
    },
  ],
  learnMoreFenrir: {
    title: '欢迎了解更多飞狼业务',
    contact: '联系我们',
  },
};
